<template>
  <div class="ads-form">
    <a-spin :spinning="loading" :tip="labels.form.loading">
      <validation-observer ref="observer">
        <a-form
          :model="form"
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(handleSubmit)"
        >
          <a-row
            type="flex"
            justify="space-between"
            :gutter="16"
            :style="{ marginBottom: '15px' }"
          >
            <!-- Title -->
            <a-col :xs="24" :md="12">
              <h2 class="form-title">
                <a-icon :type="isEdit ? 'edit' : 'form'" class="form-icon" />
                <span>{{
                  isEdit
                    ? `${labels.form.titleView} número: ${form.code || ""}`
                    : labels.form.titleCreate
                }}</span>
              </h2>
            </a-col>
            <!-- Actions -->
            <a-col :xs="24" :md="12">
              <a-row
                type="flex"
                justify="end"
                :gutter="16"
                :style="{
                  alignItems: 'flex-end',
                  marginBottom: '0px',
                }"
              >
                <a-col>
                  <a-button-group>
                    <a-button
                      :type="isEdit ? 'primary' : 'danger'"
                      ghost
                      @click="handleCancel"
                      icon="arrow-left"
                    >
                      <span>{{ labels.form.goBack }}</span>
                    </a-button>
                    <a-button
                      v-if="isEdit && canDelete"
                      type="danger"
                      @click="confirmDelete"
                    >
                      <span>{{ labels.form.deleteAd }}</span>
                    </a-button>
                    <a-button
                      v-if="!isMobile && canEdit"
                      type="primary"
                      ghost
                      :loading="submitting"
                      @click="validate().then(() => handleSubmit(true))"
                    >
                      <span>{{ labels.form.saveAndClose }}</span>
                    </a-button>
                    <a-button
                      v-if="canEdit"
                      type="primary"
                      :loading="submitting"
                      @click="validate().then(handleSubmit)"
                    >
                      <span>{{ labels.form.save }}</span>
                    </a-button>
                    <a-dropdown :trigger="['click']" v-if="isMobile && canEdit">
                      <a-menu slot="overlay">
                        <a-menu-item
                          key="1"
                          @click="validate().then(() => handleSubmit(true))"
                          >{{ labels.form.saveAndClose }}</a-menu-item
                        >
                      </a-menu>
                      <a-button type="primary" ghost icon="more" />
                    </a-dropdown>
                  </a-button-group>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <a-card>
                <a-row type="flex" justify="start">
                  <a-col :xs="24" :sm="24" :md="12">
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col>
                        <switch-input
                          v-model.lazy="form.active"
                          :label="labels.form.active.label"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col>
                        <switch-input
                          v-model.lazy="form.only_logged_in"
                          :label="labels.form.onlyLoggedIn.label"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="24">
                        <tj-input
                          v-model="form.title"
                          :vid="labels.form.title.label"
                          :label="labels.form.title.label"
                          :name="labels.form.title.label"
                          :formitem="{ label: labels.form.title.label }"
                          :placeholder="labels.form.title.placeholder"
                          rules="required"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.type"
                          :placeholder="labels.form.type.placeholder"
                          :label="labels.form.type.label"
                          :dataSource="types"
                          :allowClear="true"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <tj-input
                          v-model="form.priority"
                          type="number"
                          :vid="labels.form.priority.label"
                          :label="labels.form.priority.label"
                          :name="labels.form.priority.label"
                          :formitem="{ label: labels.form.priority.label }"
                          :placeholder="labels.form.priority.placeholder"
                          :min="0"
                          :rules="'required'"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <date-picker
                          v-model="form.start_date"
                          :show-time="false"
                          :vid="labels.form.startDate.label"
                          :name="labels.form.startDate.label"
                          :formitem="{ label: labels.form.startDate.label }"
                          :placeholder="labels.form.startDate.placeholder"
                          :format="dateFormat"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <date-picker
                          v-model="form.end_date"
                          :show-time="false"
                          :vid="labels.form.endDate.label"
                          :name="labels.form.endDate.label"
                          :formitem="{ label: labels.form.endDate.label }"
                          :placeholder="labels.form.endDate.placeholder"
                          :format="dateFormat"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <tj-input
                          v-model="form.width"
                          :vid="labels.form.width.label"
                          :label="labels.form.width.label"
                          :name="labels.form.width.label"
                          :formitem="{ label: labels.form.width.label }"
                          :placeholder="labels.form.width.placeholder"
                          rules="required|styleWidth"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <tj-input
                          v-model="form.height"
                          :vid="labels.form.height.label"
                          :label="labels.form.height.label"
                          :name="labels.form.height.label"
                          :formitem="{ label: labels.form.height.label }"
                          :placeholder="labels.form.height.placeholder"
                          rules="required|styleHeight"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <tj-input
                          v-model="form.link"
                          type="text"
                          :vid="labels.form.link.label"
                          :label="labels.form.link.label"
                          :name="labels.form.link.label"
                          :formitem="{ label: labels.form.link.label }"
                          :placeholder="labels.form.link.placeholder"
                          :rules="'url'"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.position"
                          :placeholder="labels.form.position.placeholder"
                          :label="labels.form.position.label"
                          :dataSource="positions"
                          :allowClear="true"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row
                      v-if="form.only_logged_in"
                      type="flex"
                      justify="space-between"
                      :gutter="24"
                    >
                      <a-col :xs="24" :sm="24" :md="24">
                        <select-pagination
                          v-model="form.target_users"
                          :fetchService="fetchUsers"
                          :placeholder="labels.form.targetUsers.placeholder"
                          :labelKey="'fullname'"
                          :valueKey="'id'"
                          :label="labels.form.targetUsers.label"
                          :disabledDefaultFetchOptions="false"
                          :allowClear="true"
                          mode="multiple"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="start" :gutter="24">
                      <a-col v-if="!isFileType" :span="24">
                        <a-form-item>
                          <template v-if="canEdit">
                            <wysiwyg v-model="form.content" />
                          </template>
                          <template v-else>
                            <div v-html="form.content" />
                          </template>
                        </a-form-item>
                      </a-col>
                      <a-col v-if="isFileType" :span="24">
                        <a-form-item
                          :style="{ width: '100%' }"
                          :label="labels.form.file.label"
                        >
                          <a-upload
                            :disabled="submitting"
                            :multiple="false"
                            :accept="allowedMimesTypes"
                            :file-list="fileList"
                            list-type="picture"
                            :style="{ width: '100%' }"
                            :beforeUpload="beforeUpload"
                            :openFileDialogOnClick="true"
                            :remove="handleRemoveFile"
                            @preview="handlePreviewFile"
                            :customRequest="dummyRequest"
                          >
                            <a-button
                              size="large"
                              type="primary"
                              ghost
                              class="btn-upload"
                              :disabled="submitting"
                              :block="true"
                              :style="{ width: '100%' }"
                            >
                              <a-icon type="upload"></a-icon>
                              {{ labels.form.file.placeholder }}
                            </a-button>
                          </a-upload>
                        </a-form-item>
                      </a-col>
                      <a-col
                        v-if="
                          isEdit &&
                          isFileType &&
                          isValidUri &&
                          form.content &&
                          !form.file
                        "
                        :span="24"
                      >
                        <img
                          class="img-preview"
                          :src="form.content"
                          :alt="form.title"
                          :style="{ width: '240px' }"
                          @error="isValidUri = false"
                          @click="() => handlePreviewFile(form.content)"
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>
        </a-form>
      </validation-observer>
    </a-spin>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import labels from "@/utils/labels";
import Input from "@/components/core/VeeValidateForm/Input.vue";
import DatePicker from "@/components/core/VeeValidateForm/DatePicker.vue";
import SwitchInput from "@/components/core/VeeValidateForm/Switch.vue";
import SelectPagination from "@/components/core/SelectPagination/index.vue";
import SelectValidation from "@/components/core/VeeValidateForm/Select.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import moment from "moment";
import router from "@/router";
import * as actions from "@/utils/actions";
import { mask } from "vue-the-mask";
import { adminPageTitle, hasRoles, roles } from "../../../utils/utils";

const initialFormState = {
  title: "",
  type: "image",
  width: "400px",
  height: "400px",
  content: "",
  link: "",
  position: "center",
  priority: 0,
  active: true,
  start_date: moment().startOf("day"),
  end_date: moment().endOf("day"),
  target_users: [],
  only_logged_in: false,
  file: undefined,
};

export default {
  name: "AdForm",
  directives: { themask: mask },
  components: {
    ValidationObserver,
    TjInput: Input,
    DatePicker,
    SelectPagination,
    SelectValidation,
    SwitchInput,
  },
  metaInfo: {
    title: adminPageTitle(labels.ads.title),
    titleTemplate: () => {
      return `${adminPageTitle()} - ${
        router.currentRoute.name.includes("view")
          ? labels.ads.pageTitleViewing
          : labels.ads.pageTitleCreate
      }`;
    },
  },
  data() {
    return {
      labels: labels.ads,
      loading: false,
      submitting: false,
      type: undefined,
      form: _.cloneDeep(initialFormState),
      fileList: [],
      isValidUri: true,
      types: [
        {
          label: "Imagen",
          value: "image",
        },
        {
          label: "Video",
          value: "video",
        },
        {
          label: "HTML",
          value: "html",
        },
      ],
      positions: [
        {
          label: "Centrado",
          value: "center",
        },
        {
          label: "Superior",
          value: "top",
        },
      ],
    };
  },
  async created() {
    this.resetForm();
    if (this.$route.params.id) {
      this.fetchData();
    }
  },
  computed: {
    ...mapState("ads", ["ad"]),
    ...mapState("layout", ["screenWidth"]),
    ...mapGetters("adminAuth", ["getLoggedUser"]),
    allowedMimesTypes() {
      if (this.form.type === "video") {
        return "video/*";
      }
      return `image/*`;
    },
    isFileType() {
      return ["image", "video"].includes(this.form.type);
    },
    isEdit() {
      return !!this.$route.params?.id;
    },
    canEdit() {
      const { accessRoles } = this.getLoggedUser;
      return (
        !this.isEdit || hasRoles(accessRoles, [roles.admin.ROLE_ADS_UPDATE])
      );
    },
    canDelete() {
      const { accessRoles } = this.getLoggedUser;
      return hasRoles(accessRoles, [roles.admin.ROLE_ADS_DELETE]);
    },
    dateFormat() {
      return "DD/MM/YYYY";
    },
    serverDateFormat() {
      return "YYYY-MM-DD HH:mm:ss";
    },
    serverDateFormatWithoutTime() {
      return "YYYY-MM-DD";
    },
    isMobile() {
      return this.screenWidth < 768;
    },
  },
  methods: {
    ...mapActions("ads", [
      "fetchAd",
      "createAd",
      "updateAd",
      "deleteAd",
      "resetForm",
    ]),
    ...mapActions("users", ["fetchUsers"]),
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    dummyRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    handleRemoveFile(file) {
      if (file?.uid) {
        this.form.file = undefined;
        this.fileList = this.fileList?.filter((item) => item.uid !== file.uid);
      }
    },
    handlePreviewFile(file) {
      // CREATE IMG AND OPEN IN NEW TAB
      if (this.form.type === "image") {
        const img = document.createElement("img");
        img.src = file?.url || file?.thumbUrl || file;
        img.style.maxWidth = "520px";
        const w = window.open("about:blank", "_blank", "width=520,height=auto");
        w?.document.write(img.outerHTML);
      } else if (this.form.type === "video") {
        const video = document.createElement("video");
        video.src = file.url || file.thumbUrl;
        video.controls = true;
        video.style.maxWidth = "520px";
        const w = window.open("about:blank", "_blank", "width=520,height=auto");
        w?.document.write(video.outerHTML);
      }
    },
    async beforeUpload(file) {
      const fileBase64 = await this.toBase64(file);
      this.fileList = [
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: fileBase64,
          thumbUrl: fileBase64,
        },
      ];
      this.form.file = file;
      return true;
    },
    async fetchData() {
      try {
        this.loading = true;
        await this.fetchAd(this.$route.params.id);
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
        this.$log.error(error);
        this.$router.push({ name: "admin.ads" });
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit(closeAfterSave = false) {
      if (this.submitting) return;
      this.submitting = true;
      let response = null;
      try {
        const formData = _.cloneDeep(this.form);
        formData.start_date = moment(formData.start_date).format(
          this.serverDateFormatWithoutTime
        );
        formData.end_date = moment(formData.end_date).format(
          this.serverDateFormatWithoutTime
        );

        if (this.form.type !== "html") {
          delete formData.content;
        } else {
          delete formData.file;
        }

        if (!this.form.only_logged_in) {
          delete formData.target_users;
        }

        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
          if (key === "file") {
            if (this.fileList?.length) {
              formDataToSend.append(key, formData[key], formData[key].name);
            }
          } else if (["active", "only_logged_in"].includes(key)) {
            formDataToSend.append(key, formData[key] ? 1 : 0);
          } else if (key === "target_users") {
            if (formData[key]?.length) {
              formData[key].forEach((user) => {
                formDataToSend.append("target_users[]", user?.id);
              });
            }
          } else {
            formDataToSend.append(key, formData[key]);
          }
        });

        if (this.isEdit) {
          formDataToSend.append("_method", "PUT");
        }

        response = this.isEdit
          ? await this.updateAd({ formData: formDataToSend, id: this.form.id })
          : await this.createAd({ formData: formDataToSend });

        if (response) this.$message.success(response.message);
        if (closeAfterSave) {
          this.$router.push({ name: "admin.ads" });
        } else {
          if (!this.isEdit) {
            this.$router.push({
              name: "admin.ads.edit",
              params: { id: response.data.id },
            });
          }
        }
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
      } finally {
        this.submitting = false;
      }
    },
    handleCancel() {
      this.$router.push({ name: "admin.ads" });
    },
    confirmDelete() {
      this.$confirm({
        title: this.labels.confirm.title,
        content: this.labels.confirm.subtitle,
        okText: this.labels.confirm.confirmButtonText,
        okType: "danger",
        icon: "close-circle",
        cancelText: this.labels.confirm.cancelButtonText,
        onOk: async () => {
          try {
            await this.deleteAd(this.form.id);
            this.$store.commit(`ads/${actions.GET_AD}`, null);
            this.$message.success(this.labels.deletedSuccess);
            this.$router.push({ name: "admin.ads" });
          } catch (error) {
            this.$message.error(
              error?.response?.data?.message ||
                error?.response?.message ||
                error.message ||
                this.labels.deletedError
            );
          }
        },
      });
    },
  },
  watch: {
    "$route.params.id"(value, oldValue) {
      if (value && value !== oldValue) {
        this.fetchData();
      }
    },
    ad: {
      handler(ad) {
        Object.assign(
          this.form,
          ad
            ? {
                ..._.cloneDeep(ad),
                start_date: moment(ad.start_date),
                end_date: moment(ad.end_date),
              }
            : _.cloneDeep(initialFormState)
        );
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.form = _.cloneDeep(initialFormState);
    this.resetForm();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.ads-form {
  .form-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .form-icon {
    margin-right: 8px;
  }
  .form-button-group {
    margin-top: 16px;
  }
  .img-preview {
    cursor: pointer;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    padding: 5px;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }
  }
}
::v-deep {
  .ant-input[disabled],
  .ant-time-picker-input[disabled],
  .ant-input-number-disabled,
  .ant-select-disabled .ant-select-selection {
    background-color: color(--white) !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }
}
</style>
